import { CDN2 } from '@/helpers/api';
import { setLastPageVisited } from '@/helpers/history';
import { Layout } from 'antd';
import { observer } from 'mobx-react-lite';
import Head from 'next/head';
import Image from 'next/image';
import React, { useEffect } from 'react';
import { LockOutlined } from '../Icons';
const { Content } = Layout;

function TestLayout({ children, airports }) {
  useEffect(() => {
    setLastPageVisited();
  });

  return (
    <>
      <Content className="">{children}</Content>
    </>
  );
}

export default observer(TestLayout);
